<template>
	<div class="">
		<div class="flex justify-between py-2 my-2">
			<div class="flex flex-wrap text-sm">
				<div class="ml-1">
					<label for="normal" class="relative flex items-center cursor-pointer">
						<input type="checkbox" v-model="filter" value="normal" id="normal" class="absolute opacity-0" @change="updateFilter">
						<div class="w-3 h-3 rounded-full border border-transparent bg-gray-400 ml-1"></div>
						<span class="ml-1" :class="{ 'line-through': !filter.includes('normal') }">normal</span>
					</label>
				</div>
				<div class="ml-1">
					<label for="reticulation" class="relative flex items-center cursor-pointer">
						<input type="checkbox" v-model="filter" value="reticulation" id="reticulation" class="absolute opacity-0" @change="updateFilter">
						<div class="w-3 h-3 rounded-full border border-transparent bg-purple-500 ml-1"></div>
						<span class="ml-1" :class="{ 'line-through': !filter.includes('reticulation') }">reticulation</span>
					</label>
				</div>
				<div class="ml-4 cursor-pointer text-blue-400 underline" @click="resetFilter">
					reset
				</div>
			</div>
			<div class="flex space-x-4">
				<router-link class="flex justify-center border border-gray-200 px-4 py-2 text-lg rounded hover:bg-gray-200" :to="`/forecasts/${regionid}/orders`" title="View">
					{{ region }} Forecast Orders
				</router-link>
			</div>
		</div>
		<div class="">
			<div v-if="loading" class="text-grey-darker">
				Loading...
			</div>
			<div v-else-if="!orders.length" class="text-grey-darker px-2">
				No Orders! 
			</div>
			<div v-else>
				<div class="px-2 py-2 bg-gray-200 mb-2" v-for="(order, index) in orders" :key="index">
					<div class="flex justify-between items-center space-x-10 cursor-pointer" @click="toggleShow(index)">
						<h3 class="flex items-center uppercase w-8/12 sm:w-3/5" title="View">
							<h2 class="ml-2 text-lg font-normal text-gray-700 sm:ml-4">{{ order.formated_datetime }}</h2>
						</h3>
					</div>
					<div class="bg-white mt-2 p-2" v-if="show.includes(index)">
						<div class="flex space-x-2">
							<template v-for="ordernumber in order.ordernumbers">
								<router-link class="flex items-center space-x-2 bg-gray-100 px-2 py-1 rounded shadow" :to="`/forecasts/${ordernumber == 'Warehouse' ? 'w-'+order.timestamp : ordernumber }/breakdown`">
									{{ ordernumber }}
								</router-link>							
							</template>							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ForecastHistory',
	data () {
		return {
			orders: [],
			loading: true,
			role: null,
			regionid: this.$route.params.regionid,
			regions: {
				'1': 'Gauteng',
				'2': 'KZN',
				'3': 'Cape Town',
			},
			filter: [
				'normal',
				'reticulation',
			],
			filtered: false,
			show: [],
		}
	},
	computed: {
		isAdmin: function(){
			return this.role === 'Administrator' || this.role === 'Super Admin';
		},
		region: function(){
			return this.regions[this.regionid];
		},
	},
	methods: {
		pad: function(n, width, z){
			z = z || '0';
			n = n + '';
			return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
		},
		toggleShow: function(index){
			let theIndex = this.show.indexOf(index);
			if(theIndex == -1){
				this.show.push(index);
				return;
			}
			this.show.splice(theIndex, 1);
		},
		resetFilter: function(){
			this.filter = [
				'normal',
				'reticulation',
			];
			this.filtered = false;
			this.updateFilter();
		},
		updateFilter: function(){
			this.$nextTick(() => {
				let oldVal = this.$route.query.filter ? this.$route.query.filter.split(',') : [];
				let newVal = this.filter;
				if(JSON.stringify(oldVal.slice().sort()) != JSON.stringify(newVal.slice().sort())){
					this.$router.push({ route: 'Forecast Orders',query: { filter: this.filter.join() } });
				}
			});
		},
		loadData: function () {
				//console.log(this.$route.query.filter);
				let query  = this.filter.length ? `?filter=${this.filter.join()}` : '';
				this.$http.get(`forecast/${this.regionid}/history${query}`)
			.then((response) => {
				this.orders = response.data.orders ? Object.values(response.data.orders) : [];
				this.show = Object.keys(this.orders).map(x => parseInt(x));
			})
			.then(() => {
				this.loading = false;
			})
		},

	},
	created () {
		if(this.$route.query.filter){
			this.filter = this.$route.query.filter.split(',');
		}
		this.role = this.$store.getters['auth/role']
		this.$store.commit('setJobName', null)
		this.loadData();
	}
}
</script>
<style lang="css" scoped>
	.orderedClass {
		@apply border-transparent bg-red-400;
	}
	.processingClass {
		@apply border-red-400;
	}
	.problemClass {
		@apply border-transparent bg-yellow-500;
	}
	.receivedClass {
		@apply rounded-full bg-green-500 text-white;
	}
	.completeClass {
		@apply border-transparent bg-gray-300;
	}
</style>